<script>
import { s__ } from '~/locale';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { computeTrustedUrls } from 'ee/ai/shared/utils/trusted_urls_utils';
import DuoAgenticChatView from './duo_agentic_chat_view.vue';
import AgenticModeToggle from './agentic_mode_toggle.vue';
import DuoDisabledEmptyState from './duo_disabled_empty_state.vue';

export default {
  name: 'DuoAgenticChatBlockedStateView',
  components: { DuoAgenticChatView, AgenticModeToggle, DuoDisabledEmptyState },
  mixins: [glFeatureFlagsMixin()],
  inject: {
    chatConfiguration: { default: () => ({}) },
    badgeType: {},
  },
  props: {
    isDuoDisabled: { type: Boolean, required: true },
    isClassicAvailable: { type: Boolean, required: true },
    forceAgenticModeForCoreDuoUsers: { type: Boolean, required: true },
    duoSettingsPath: { type: String, required: false, default: null },
    projectId: { type: String, required: true },
    trustedUrls: { type: Array, required: false, default: () => [] },
  },
  emits: ['return-to-classic'],
  computed: {
    namespaceType() {
      return this.projectId ? 'project' : 'group';
    },
    computedTrustedUrls() {
      return computeTrustedUrls(this.trustedUrls);
    },
  },
  chatState: { isEnabled: false, reason: s__('DuoAgenticChat|GitLab Duo is disabled') },
  emptyMessages: [],
};
</script>

<template>
  <duo-agentic-chat-view
    id="duo-chat"
    is-multithreaded
    show-header
    multi-threaded-view="chat"
    :chat-state="$options.chatState"
    :badge-type="badgeType"
    :messages="$options.emptyMessages"
    :show-studio-header="
      chatConfiguration.defaultProps && chatConfiguration.defaultProps.isEmbedded !== false
    "
    :trusted-urls="computedTrustedUrls"
    class="gl-h-full gl-w-full"
  >
    <template v-if="isClassicAvailable && !forceAgenticModeForCoreDuoUsers" #agentic-switch>
      <agentic-mode-toggle :value="true" @change="$emit('return-to-classic')" />
    </template>
    <template #custom-empty-state>
      <duo-disabled-empty-state
        v-if="isDuoDisabled"
        key="duo-disabled-empty-state"
        :duo-settings-path="duoSettingsPath"
        :namespace-type="namespaceType"
      />
    </template>
  </duo-agentic-chat-view>
</template>
